"use client";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import "./Privacy.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPrivacyPolicies,
  selectAllPrivacyPolicies,
} from "@/slice/privacyPolicySlice";
import MarkdownComp from "./markdown";
export default function PrivacyPolicy() {
  const dispatch = useDispatch();
  const data = useSelector(selectAllPrivacyPolicies);

  const privacyPolicy = data?.data?.map((i) => ({
    title: i?.title,
    descrption: i?.descrption,
  }));

  useEffect(() => {
    dispatch(fetchPrivacyPolicies());
  }, []);
  return (
    <>
      <BreadCrumbs />
      <div className="termsWrapper">
        <div className="termsContainer">
          <p className="heading">
            <span className="highlightHeading">Privacy Policy</span>
          </p>
          <div className="termsInfo">
            <p className="termsInfoParagraph">
              This privacy statement describes how we use the information you
              provide to us or we gather from you while you use the FitSib
              online services, as provided by FEHYPE ONLINE SERVICES PRIVATE
              LIMITED. (FitSib or “us” or “we”). It also describes the choices
              available to you regarding our use of your personal information
              and how you can access and update this information. It is
              important that you have a comprehensive understanding of our
              information collection and usage practices. In your best
              interests, we advise that you read each provision of this Privacy
              Policy. By visiting, accessing or using the FitSib website
              (FitSib.com), mobile applications and all associated services,
              features and content (“Service” or “Services”), you acknowledge
              agreement to this Privacy Policy. If we change our Privacy Policy,
              we will post those changes to this Privacy Policy. We retain the
              exclusive right to amend this Policy from time to time. If we make
              any substantial changes in the way that we use your personal
              information, we will notify you by posting a prominent
              announcement on our Site. We encourage you to periodically review
              this page for the latest information on our privacy practices.
            </p>
          </div>

          {privacyPolicy?.map((i) => (
            <div className="infoService" key={i?.title}>
              <p className="subheading">
                <span className="subHighlightHeading">{i?.title}</span>
              </p>

              <div className="infoDetails">
                <div className="infoParagraph">
                  <MarkdownComp content={i?.descrption} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
